import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import * as yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { ModalAllder } from "layouts/ModalAllder";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

export function UserAdminSuccessModal({ modal, setModal, type = "create" }) {
  const getMessage = () => {
    switch (type) {
      case "update":
        return "อัพเดทแพ็คเพจสำเร็จ";
      case "delete":
        return "ลบแพ็คเพจสำเร็จ";
      default:
        return "สร้างแพ็คเพจสำเร็จ";
    }
  };

  return (
    <>
      <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
        <div className="py-4">
          <div className="">
            <div className="text-center mb-4">
              <CheckCircleRoundedIcon className="!text-[100px] text-[#2DC76D]" />
            </div>
            <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
              {getMessage()}
              <br />
            </div>
          </div>
        </div>
      </ModalAllder>
    </>
  );
}
